import { useState } from "react";

import { formatAnnotationStyleSize, StyleSize } from "./AnnotationSettings";

import styles from "./FreehandAnnotationSettings.module.scss";

interface FreehandAnnotationSettingsProps {
    /** On freehand settings selection. */
    onChange: (styles: Record<string, string>) => void;

    /** Display freehand settings */
    isVisible: boolean;

    /** Up to 3 values */
    values: StyleSize[];
}

/** A React component that display settings for freehand annotation tools. */
function FreehandAnnotationSettings(props: FreehandAnnotationSettingsProps): JSX.Element {
    const [stroke, setStroke] = useState<StyleSize>(props.values.firstOrDefault(p => p.isDefault));

    function changeStroke(value: StyleSize): void {
        setStroke(value);
        props.onChange({ StrokeThickness: formatAnnotationStyleSize(value) });
    }

    const sortedValue = props.values.sortByProperties(p => p.value);

    return (
        <div className={!props.isVisible ? "hidden" : ""}>
            <ul className={`${styles.dots}`}>
                {sortedValue.map((strokeSize, index) => (
                    <li
                        onClick={() => changeStroke(strokeSize)}
                        key={strokeSize.value}
                    >
                        <i className={`${getDotStyleClassName(index)} ${stroke === strokeSize ? styles.selected : ""}`} />
                    </li>
                ))}
            </ul>
        </div>
    );
}

function getDotStyleClassName(index: number): string {
    switch (index) {
        case 0:
            return styles.smallDot;
        case 1:
            return styles.mediumDot;
        case 2:
            return styles.largeDot;
        default:
            console.error("Stroke thickness value not supported");
            return "";
    }
}

export { FreehandAnnotationSettings };
